import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import * as accessToken from '../utils/accessToken';
import { setAuth, logout } from "../redux/user.act";

export default () => {
  const dispatch = useDispatch();
  const user = useSelector(({ user }) => user);
  const { data } = user;
  const { VisitId = '' } = data || {};

  const token = accessToken.get();

  const isLoggedIn = () => !!(token);

  useEffect(() => {
    // Force logout (clean global state) when there is no cookie.
    if (VisitId && !token) {
      dispatch(logout());
    }
  }, [dispatch, token, VisitId]);

  useEffect(() => {
    if (token) {
      // Fetch user data on load.
      //dispatch(userFetch());
    }
  }, [dispatch, token]);

  return {
    isLoggedIn,
    user,
  };
}
